var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7465 15.2428C13.7235 14.0692 12.4495 12.81 11.509 11.9429L12.627 4.08331C13.7723 5.13923 17.5423 10.9372 18.7845 12.4456C19.3849 13.1746 19.9956 13.9996 20.3637 14.7761C20.5327 15.1326 20.7782 15.7345 20.7766 16.4559C20.7757 16.8525 20.6997 17.3819 20.406 17.9287C20.098 18.502 19.6461 18.9161 19.1684 19.176C18.6666 19.4488 18.1541 19.5998 17.7064 19.6878C17.8499 19.8271 18.0087 19.9724 18.1838 20.1232C19.1296 20.9382 20.2444 21.6629 21.1983 22.2801C21.7785 22.6553 23.273 23.359 25.0883 24.1428C26.8364 24.8976 28.6996 25.6501 29.8774 26.1107L28.6461 28.5999L23.4187 27.4435L19.4893 26.2577L17.0447 25.1625C17.0447 25.1625 16.2374 24.9375 15.0635 23.926C13.9418 22.9595 12.6007 21.5609 12.1369 19.7711C11.9124 18.9047 11.7902 17.3914 13.0062 16.1872C13.5054 15.6929 14.0526 15.4538 14.4379 15.3296C14.5424 15.2959 14.6458 15.2672 14.7465 15.2428ZM16.2243 17.2664C16.2243 17.2664 16.2223 17.2587 16.2155 17.2422C16.2204 17.258 16.2243 17.2664 16.2243 17.2664ZM16.5873 18.117C16.5873 18.117 16.5877 18.1202 16.5892 18.127C16.5881 18.1205 16.5873 18.117 16.5873 18.117Z",
    fill: "url(#paint0_linear_1317_31810)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7358 29.376C13.2357 29.0754 11.4777 28.8197 10.2139 28.6678L6.875 23.625C8.414 23.81 14.7445 25.7836 16.6114 26.1975C17.5137 26.3977 18.4769 26.6502 19.2096 26.9666C19.5459 27.1119 20.0804 27.3721 20.4719 27.7966C20.6871 28.0299 20.9114 28.3699 20.962 28.8029C21.0149 29.2567 20.86 29.6718 20.5994 30.006C20.3256 30.3571 19.9764 30.6406 19.6476 30.8625C19.8442 30.8898 20.057 30.9148 20.2865 30.9368C21.5264 31.056 22.8593 31.0581 23.9982 31.0581C24.6909 31.0581 26.332 30.9036 28.2868 30.674C30.1692 30.453 32.1471 30.1868 33.3894 30.0099L33.7083 31.9403L28.6788 33.2479L24.7257 34.0449L22.0719 34.3306C22.0719 34.3306 21.2698 34.5051 19.7309 34.3571C18.2605 34.2157 16.3701 33.9036 15.0052 33.0284C14.3444 32.6048 13.4175 31.7622 13.7853 30.5923C13.9363 30.1121 14.2666 29.7637 14.5233 29.5442C14.5929 29.4847 14.6643 29.4285 14.7358 29.376ZM17.0816 30.0032C17.0816 30.0032 17.0757 29.9994 17.061 29.9924C17.0738 29.9997 17.0816 30.0032 17.0816 30.0032ZM17.8502 30.365C17.8502 30.365 17.8524 30.3667 17.8574 30.3702C17.8529 30.3667 17.8502 30.365 17.8502 30.365Z",
    fill: "url(#paint1_linear_1317_31810)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.125 31.2083C61.125 41.5177 52.7677 52.2083 42.4585 52.2083C32.149 52.2083 23.7917 41.5177 23.7917 31.2083C23.7917 20.899 32.149 15.75 42.4585 15.75C52.7677 15.75 61.125 20.899 61.125 31.2083Z",
    fill: "url(#paint2_linear_1317_31810)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.125 31.2083C61.125 41.5177 52.7677 52.2083 42.4585 52.2083C32.149 52.2083 23.7917 41.5177 23.7917 31.2083C23.7917 20.899 32.149 15.75 42.4585 15.75C52.7677 15.75 61.125 20.899 61.125 31.2083Z",
    fill: "url(#paint3_linear_1317_31810)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1603 42.7231C26.8335 39.4068 25.4396 35.3577 25.4396 31.3721C25.4396 22.1331 32.9293 17.5187 42.1682 17.5187C47.9247 17.5187 53.0021 19.3102 56.0118 22.8952C53.1554 18.6128 47.6753 16.4732 41.3841 16.4732C32.1451 16.4732 24.6556 21.0877 24.6556 30.3266C24.6556 34.7417 26.3659 39.2348 29.1603 42.7231Z",
    fill: "#A5A9AB",
    fillOpacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9165 30.3389C57.9165 36.9164 50.2484 43.4583 42.3125 43.4583C34.3764 43.4583 26.7083 36.9164 26.7083 30.3389C26.7083 23.7612 34.3764 25.2214 42.3125 25.2214C50.2484 25.2214 57.9165 23.7612 57.9165 30.3389Z",
    fill: "url(#paint4_linear_1317_31810)",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1317_31810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8285 31.4022C55.1681 33.3547 53.4136 35.2907 50.9093 35.7264C48.4051 36.1622 46.0995 34.9326 45.7598 32.9802C45.4201 31.0277 46.8709 30.5081 49.3751 30.0724C51.8794 29.6366 54.4888 29.4497 54.8285 31.4022Z",
    fill: "#0CC5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6568 31.4022C29.3171 33.3547 31.0717 35.2907 33.5759 35.7264C36.0802 36.1622 38.3858 34.9326 38.7255 32.9802C39.0652 31.0277 37.6146 30.5081 35.1103 30.0724C32.6061 29.6366 29.9965 29.4497 29.6568 31.4022Z",
    fill: "#0CC5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1317_31810",
    x: 26.6147,
    y: 28.7866,
    width: 31.2557,
    height: 12.0276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.772549 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1317_31810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1317_31810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1317_31810",
    x1: 27.5833,
    y1: 29.75,
    x2: 3.08336,
    y2: 16.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#777E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#8E9496",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1317_31810",
    x1: 27.5833,
    y1: 29.75,
    x2: 3.08333,
    y2: 16.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#777E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#8E9496",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1317_31810",
    x1: 61.125,
    y1: 39.375,
    x2: 23.7917,
    y2: 29.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#140716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D5970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1317_31810",
    x1: 61.125,
    y1: 39.375,
    x2: 26.7085,
    y2: 23.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#11181B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#1D282D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#4A5357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E9496"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1317_31810",
    x1: 38.8275,
    y1: 25.0353,
    x2: 42.7573,
    y2: 43.8106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#7DA2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91A1A7",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.1fd58825ebee3f9b15a04561ef5b255b.svg";
export { ForwardRef as ReactComponent };